import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FcOutlinedTextareaComponent } from './fc-outlined-textarea.component';

@NgModule({
  declarations: [
    FcOutlinedTextareaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextFieldModule,
  ],
  exports: [
    FcOutlinedTextareaComponent
  ]
})
export class FcOutlinedTextareaModule { }
